module.exports = __webpack_public_path__ + "media/entities/2315-675ffc3f.png";